import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import React from 'react';
import {LogViewerDialog} from './LogViewerDialog';
import qs from 'query-string';
import {TimeLogFilter} from 'types/diplomat/logs/TimeLogFilter';
import {TransactionLogFilter} from 'types/diplomat/logs/TransactionLogFilter';
import {useToasts} from 'features/notifications/useToasts';
import {useTranslation} from 'react-i18next';
import {ILastStartEndTimeResponse} from 'types/JobHistory';
import {AlertDialog} from 'components/dialogs/AlertDialog';

type Props = {
   data: INav;
   onClose: () => void;
};

export const LogViewerLastStartEndDialog = React.memo(({data, onClose}: Props) => {
   const {t} = useTranslation();
   const {addToast} = useToasts();

   const [error, setError] = React.useState<String>();
   const options = React.useMemo(
      () => ({
         onSuccess: (times: ILastStartEndTimeResponse) => {
            if (!times || !times.lastStartEndTimes[0]) {
               setError(
                  t('No logs found for transaction {{transactionName}}', {
                     transactionName: data.name,
                  })
               );
            }
         },
      }),
      [addToast, data.name, t]
   );

   const {request, state: startEndTimes} = useGetApi<ILastStartEndTimeResponse>(
      qs.stringifyUrl({
         url: api.jobhistory,
         query: {operation: 'lastStartEndTimes', transactionName: data.name},
      }),
      options
   );
   React.useEffect(() => {
      request();
   }, [request]);

   const filters = React.useMemo(() => {
      if (startEndTimes?.lastStartEndTimes[0] || startEndTimes?.lastStartEndTimes[1]) {
         const [earliestTime, latestTime] = startEndTimes.lastStartEndTimes;

         const timeLogFilter = TimeLogFilter.cast({
            earliestTime,
            latestTime,
         });
         const transFilter = TransactionLogFilter.cast({transNames: [data.name]});

         return [timeLogFilter, transFilter];
      }
      return null;
   }, [data.name, startEndTimes]);

   return error ? (
      <AlertDialog content={error} onClose={onClose} />
   ) : (
      filters && <LogViewerDialog logFilters={filters} onClose={onClose} />
   );
});
